import { render, staticRenderFns } from "./TechStatusesPanel.vue?vue&type=template&id=5c33380e&"
import script from "./TechStatusesPanel.vue?vue&type=script&lang=js&"
export * from "./TechStatusesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports